import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import { Calendar, dayjsLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import CalendarDateHeader from './components/calendarDateHeader';
import CalendarEvent from './components/calendarEvent';
import CalendarMonthHeader from './components/calendarMonthHeader';
import CalendarToolbar from './components/calendarToolbar';
import { CalendarEventsList } from './services/entity';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import CalendarEventDetails from './components/calendarEventDetails';
import { AppointmentKeys } from '../../appointmentV3/services/entity';
function CRMCalendar() {
    var _crud$AppointmentKeys, _crud$AppointmentKeys2;
    var crud = useAppSelector(function (state) { return state.crud; });
    var eventsList = (_crud$AppointmentKeys = (_crud$AppointmentKeys2 = crud[AppointmentKeys.Paging]) === null || _crud$AppointmentKeys2 === void 0 ? void 0 : _crud$AppointmentKeys2.data) !== null && _crud$AppointmentKeys !== void 0 ? _crud$AppointmentKeys : [];
    var localizer = dayjsLocalizer(dayjs);
    var dispatch = useAppDispatch();
    var baseRequest = {
        "Branches": ["c247b74a-8222-4363-b693-0d54a710fa08"],
        "Status": "",
        "FromDate": "",
        "ToDate": "",
        "take": 999,
        "skip": 0
    };
    var onSelectEvent = function (item) {
        dispatch(showSurface({
            type: 'Dialog',
            containerProps: {
                maxWidth: 'xs',
                fullWidth: true
            },
            Component: CalendarEventDetails,
            componentProps: {
                request: _objectSpread(_objectSpread({}, item), {}, {
                    Mobile: 9876543210,
                    ProductModel: 'Bajaj Avenger Street 160',
                    AppointmentDate: dayjs(item.SlotStartTime).format('DD MMM, YYYY - h:mm A')
                })
            }
        }));
    };
    return /*#__PURE__*/ React.createElement(Box, {
        height: "calc(100vh - 160px)"
    }, /*#__PURE__*/ React.createElement(Calendar, {
        localizer: localizer,
        events: CalendarEventsList,
        startAccessor: "SlotEndTime",
        endAccessor: "SlotStartTime",
        titleAccessor: "CustomerName",
        toolbar: true,
        views: {
            day: false,
            week: false,
            month: true
        },
        drilldownView: null,
        popup: true,
        step: 120,
        components: {
            event: CalendarEvent,
            toolbar: function (props) { /*#__PURE__*/ return React.createElement(CalendarToolbar, _extends({}, props, {
                count: CalendarEventsList === null || CalendarEventsList === void 0 ? void 0 : CalendarEventsList.length
            })); },
            month: {
                dateHeader: CalendarDateHeader,
                header: CalendarMonthHeader
            }
        },
        onSelectEvent: onSelectEvent
    }));
}
export default CRMCalendar;
